import { useMemo } from 'react'
import { DynamicContentType, ImageCollageData } from '@bm-js/atlascloud-shared'
import { useImageOptions, useMargin } from '../utils/hooks'
import { ResponsiveImage } from './ResponsiveImage'

type Props = {
  content: DynamicContentType<ImageCollageData>
}

export const ImageCollage = ({ content }: Props) => {
  const imageOptions = useImageOptions(content)

  const positionClasses = useMemo(() => {
    let primary = '-translate-x-[5%] -translate-y-[5%]'
    let secondary = 'right-0 bottom-0 '

    if (content.data.layout === 'bottomLeft') {
      primary = 'translate-x-[5%] -translate-y-[5%]'
      secondary = 'left-0 bottom-0 '
    }

    return {
      primary,
      secondary,
    }
  }, [content.data.layout])

  const margin = useMargin(content)
  return (
    <div className={`${margin} relative`}>
      <ResponsiveImage
        file={content.data.mainImage}
        className={`${imageOptions} ${positionClasses.primary} scale-[90%] w-full`}
      />
      <ResponsiveImage
        file={content.data.secondaryImage}
        className={`${imageOptions} ${positionClasses.secondary} absolute w-1/2`}
      />
    </div>
  )
}
